import "./StyleHintBlock.css"
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import React, {useEffect, useState} from "react";
import {FetchElements, GetCookie, updateRefreshToken} from "../../../utils/js/request";
import HintBlockData from "./HintBlockData";
import {GET_SELECTED_SHOP_ID, REQUEST} from "../../../utils/js/Const";
import {useNavigate} from "react-router-dom";
import DataUndefaind from "../../DataUndifaend/DataUndefaind";
import {NexTitle} from "../../../utils/js/UtilsJs";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";


function HintBlock({   }) {
    NexTitle("Подсказки")
    let navigate = useNavigate();
    let selectedId = GET_SELECTED_SHOP_ID();

    const [block, setBlock] = useState({auto_tasks: [], manual_tasks: []})
    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));
    const [dataLoaded, setDataLoaded] = useState(false)
    const [autoTask, setAutoTask] = useState([])
    const [manualTask, setManualTask] = useState([])

    useEffect(() => {
        setAutoTask(block.auto_tasks);
        setManualTask(block.manual_tasks);
    },[block]);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('');
    const [alertLoadingGif, setAlertLoadingGif] = useState('');

    const handleOpenAlert = (title, message, statusCod, LaodingGif) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
        setAlertLoadingGif(LaodingGif);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
        setAlertLoadingGif('');
    };


    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken,null,()=>{navigate("/")});
                if (newToken) {
                    loadData();
                }
            } else {
                loadData();
            }
        };
        fetchData();
    }, [accessToken]);

    const loadData = () => {
        if(selectedId === 0){
            handleOpenAlert('Уведомление', `Выберите магазин!`, ``, '');
            setTimeout(() =>    navigate(-1), 1500);
        }else{
            FetchElements(`${REQUEST}/api/v1/groups_tasks?shop_id=${selectedId}`, "GET", setBlock,  navigate,2,() => navigate("/"),handleOpenAlert)
                .then((data) => setDataLoaded(true))
        }

    };

    function getNewHint(_groups_tasks_id, _shop_id ,_count){
        // Показываем алерт загрузки
        handleOpenAlert('Уведомление', `Идет загрузка`, ``, "loader");

        FetchElements(
            `${REQUEST}/api/v1/groups_tasks/${_groups_tasks_id}/more?shop_id=${_shop_id}&count=${_count}`,
            "GET",
            (data) => {
                handleCloseAlert();
                loadData();
            },
            navigate,
            2,
            () => navigate(),
            (title, message, statusCod) => {
                handleCloseAlert();
                handleOpenAlert(title, message, statusCod, '');
            }
        )
    }

    return (
        <>
            <ButtonBack/>
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                statusCod={alertStatusCod}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
                classAlertLoading={alertLoadingGif}
            />
            {
                dataLoaded && autoTask?.length === 0 && manualTask?.length === 0 ?
                    <DataUndefaind text={`У вас сейчас нет подсказок`}/> :
                    null
            }
            { autoTask?.length > 0 ? <div className="hint--category max--width--control">Автоматические подсказки</div> : <div></div>}
            {HintBlockData(autoTask, getNewHint)}
            { manualTask?.length > 0 ?<div className="hint--category max--width--control">Ручные подсказки:</div> : <div></div>}
            {HintBlockData(manualTask, getNewHint)}
        </>
    )
}

export default HintBlock;